"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackedState = exports.useSetState = exports.SharedStateProvider = void 0;
const react_1 = require("react");
const react_tracked_1 = require("react-tracked");
const initialState_1 = __importDefault(require("./initialState"));
const useValue = () => (0, react_1.useState)(initialState_1.default);
_a = (0, react_tracked_1.createContainer)(useValue), exports.SharedStateProvider = _a.Provider, exports.useSetState = _a.useUpdate, exports.useTrackedState = _a.useTrackedState;
